module.exports = __webpack_public_path__ + "img/show4.07d83b85.jpg";